import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { updatePromotionalCode } from "../api/updatePromotionalCode";

export const useUpdatePromotionalCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }) => updatePromotionalCode(id, body),
    onSuccess: () => {
      toast.success("Promotional code updated successfully!");
      queryClient.invalidateQueries({ queryKey: ["promotionalCodes"] });
      queryClient.invalidateQueries({ queryKey: ["promotionalCodeDetails"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to update promotional code.");
    },
  });
};

